export default "__VITE_ASSET__aN1QkG7s__"